import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-pcomp-glyphicons-page-configurator',
	templateUrl:'./GlyphiconsPageConfiguratorPluginCompPage.html',
	styles: [],
	styleUrls:['./GlyphiconsPageConfiguratorPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class GlyphiconsPageConfiguratorPluginCompPage
{
	mdContent_979 = `\`\`\`java
import com.jwebmp.plugins.glyphicons.GlyphiconsPageConfigurator;
\`\`\``;
	mdContent_980 = `\`\`\`java
module com.myapp {
    requires com.jwebmp.plugins.glyphicons;
}
\`\`\``;
}
